<script>
    /**
     * This program is free software; you can redistribute it and/or
     * modify it under the terms of the GNU General Public License
     * as published by the Free Software Foundation; under version 2
     * of the License (non-upgradable).
     *
     * This program is distributed in the hope that it will be useful,
     * but WITHOUT ANY WARRANTY; without even the implied warranty of
     * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
     * GNU General Public License for more details.
     *
     * You should have received a copy of the GNU General Public License
     * along with this program; if not, write to the Free Software
     * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
     *
     * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
     */

    import { onDestroy, onMount } from 'svelte';
    import { Router, createMemorySource, createHistory } from 'svelte-navigator';
    import layout from './stores/layout.js';
    import RoutingTable from './RoutingTable.svelte';

    import Navbar from './components/Navbar/Navbar.svelte';

    export let initialPathname = '/start';

    let navbarWrapper = null;
    let navbarHeight = 0;

    const history = createHistory(createMemorySource(initialPathname));
    const unlisten = history.listen(onNavigate);
    const navbarResizeObserver = new ResizeObserver(([navbarWrapperEntry]) => {
        navbarHeight = navbarWrapperEntry.target.clientHeight;
    });

    onDestroy(() => {
        unlisten();
        navbarResizeObserver.disconnect();
    });
    onMount(() => {
        navbarResizeObserver.observe(navbarWrapper);
    });

    function onNavigate() {}
</script>

<Router>
    <div class={`app-layout ${$layout}`} style={`--navbar-height: ${navbarHeight}px`}>
        <div class="navbar-wrapper" bind:this={navbarWrapper}>
            <Navbar />
        </div>
        <main class="content">
            <Router primary={false}>
                <RoutingTable />
            </Router>
        </main>
    </div>
</Router>

<style>
    .content {
        --padding-y: var(--space-6x);
        padding: calc(var(--padding-y) + var(--navbar-height)) 0 var(--padding-y);
    }

    .app-layout.centered {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        min-width: 100%;
    }

    .navbar-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
    }
</style>
